import React, { useEffect, useState, useContext } from "react";
import { PatientContext } from "../../lib/main-context";
import { useTranslation } from "../../i18n/TranslationProvider";
import { useHistory, useLocation } from "react-router-dom";

import Row from "react-bootstrap/Row";
import Sallie from "../UIComponents/Sallie";
import ListSelector from "../UIComponents/ListSelector";
import useListSelector from "../../lib/useListSelector";
import OnboardingStepHeader from "./OnboardingStepHeader";
import SubmitButton from "../UIComponents/SubmitButton";

import { postTrackedFactors } from "../../api/TBIRequests";

const SelectTopTriggers = ({ setOnboardingPercent, user }) => {
  const { patient } = useContext(PatientContext);
  const { t } = useTranslation();

  const history = useHistory();
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  const { forwardData } = location.state || { forwardData: undefined };
  const [returnedData, setReturnedData] = useState([]);

  const { toggleFromSelectedList, switchSingleSelection, selectedData, initialize } =
    useListSelector({ setInitialData: setReturnedData, initialData: returnedData });

  const createItemList = () => {
    return [{ category: "data", items: Object.values(forwardData).flat(), maxSelectAmount: "3" }];
  };

  useEffect(() => {
    if (!forwardData) {
    } else {
      const itemList = createItemList();
      initialize(itemList);
      setReturnedData(itemList);
    }
    setLoading(false);
    setOnboardingPercent(70);
  }, [forwardData]);

  const processDataForSending = () => {
    return forwardData.processedData
      .filter((item) => selectedData.data.flat().includes(item.factor))
      .map((item) => ({ factor: item.factor, category: item.category, subcategory: item.subcategory }));
  };

  const handleSubmit = () => {
    const mappedData = processDataForSending();
    postTrackedFactors({
      patientId: patient.patientId,
      therapistId: user.userType === "Therapist" ? user.userId : null,
      data: mappedData,
    })
      .then(() => history.push("/notificationPrefs"))
      .catch(() => history.push("/oops"));
  };

  return (
    <>
      {loading ? (
        t("common.loading")
      ) : (
        <>
          <OnboardingStepHeader text={t("toptriggers.header")} />
          <Sallie text={t("toptriggers.sallie")} />
          {returnedData.map((itemList, i) => (
            <ListSelector
              key={itemList.category}
              category={itemList.category}
              message={t("toptriggers.message")}
              list={itemList.items}
              index={i}
              selectedList={selectedData[itemList.category]}
              toggleFromSelectedList={toggleFromSelectedList}
              selectOne={switchSingleSelection}
              maxSelectAmount={itemList.maxSelectAmount}
              noOther
              noSuffix
            />
          ))}
          <Row>
            <SubmitButton onClick={handleSubmit}>
              {t("onboarding.saveContinue")} &gt;
            </SubmitButton>
          </Row>
        </>
      )}
    </>
  );
};

export default SelectTopTriggers;